import * as yup from 'yup';

import { ERROR_MESSAGES } from '@/shared/constants/error-messages';

export const formProviderInitialValue = {
    bin: '',
    pcn: '',
};

export const formInitialValues = {
    provider: formProviderInitialValue,
    cardHolderID: '',
    groupID: '',
};

export const addInsuranceValidationSchema = yup.object().shape({
    provider: yup.object().shape({
        bin: yup.string().trim().required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING).min(6, 'Bin should have 6 digits'),
        pcn: yup.string().trim().required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING)
    }),
    cardHolderID: yup.string().trim().required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING),
    groupID: yup.string().trim()
});

export type AddInsuranceSchema = yup.InferType<typeof addInsuranceValidationSchema>;